/* tslint:disable */
import {
  Teomemppersonal
} from '../index';

declare var Object: any;
export interface StsmartnoticecommentsInterface {
  "id"?: number;
  "smartId"?: number;
  "userId"?: number;
  "fullname"?: string;
  "picture"?: string;
  "comments"?: string;
  "createdDate"?: Date;
  "companyId"?: number;
  "codename"?: string;
  rel_personal?: Teomemppersonal;
}

export class Stsmartnoticecomments implements StsmartnoticecommentsInterface {
  "id": number;
  "smartId": number;
  "userId": number;
  "fullname": string;
  "picture": string;
  "comments": string;
  "createdDate": Date;
  "companyId": number;
  "codename": string;
  rel_personal: Teomemppersonal;
  constructor(data?: StsmartnoticecommentsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Stsmartnoticecomments`.
   */
  public static getModelName() {
    return "Stsmartnoticecomments";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Stsmartnoticecomments for dynamic purposes.
  **/
  public static factory(data: StsmartnoticecommentsInterface): Stsmartnoticecomments{
    return new Stsmartnoticecomments(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Stsmartnoticecomments',
      plural: 'Stsmartnoticecomments',
      path: 'Stsmartnoticecomments',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "smartId": {
          name: 'smartId',
          type: 'number'
        },
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "fullname": {
          name: 'fullname',
          type: 'string'
        },
        "picture": {
          name: 'picture',
          type: 'string'
        },
        "comments": {
          name: 'comments',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "codename": {
          name: 'codename',
          type: 'string'
        },
      },
      relations: {
        rel_personal: {
          name: 'rel_personal',
          type: 'Teomemppersonal',
          model: 'Teomemppersonal'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Stsmartnoticecomments.ts